import { render, staticRenderFns } from "./paper_size.vue?vue&type=template&id=17340cee&scoped=true&"
import script from "./paper_size.vue?vue&type=script&lang=js&"
export * from "./paper_size.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17340cee",
  null
  
)

export default component.exports